@if (isLink()) {
  <a
    [routerLink]="route()"
    class="neon-button"
    [class.full-width]="fullWidth()"
    [class.size-lg]="size()"
    [class.has-icon]="hasIcon()"
    [class.neon-button--secondary]="mode()"
  >
    <span class="relative z-2">{{ label() }}</span>

    @if (hasIcon()) {
      <svg
        class="btn-icon"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 5L16 12L9 19"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </a>
} @else {
  <button
    [type]="type()"
    class="neon-button"
    [class.full-width]="fullWidth()"
    [class.has-icon]="hasIcon()"
    [disabled]="disabled()"
  >
    {{ label() }}

    @if (hasIcon()) {
      <svg
        class="btn-icon"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 5L16 12L9 19"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </button>
}
